import { FC } from "react";

import type { HandoffCardContent } from "../../helpers/useOrganizationApprovalDescription";
import { DetailRow } from "../DetailRow/DetailRow";

import { useTranslate } from "@/common/hooks/useTranslate";

interface HandoffDetailsProps {
  card: HandoffCardContent;
}

export const HandoffDetails: FC<HandoffDetailsProps> = ({ card }) => {
  const { t } = useTranslate();
  return (
    <>
      {card.replyEmail && (
        <DetailRow label={t("dashboard", "organizationAssistant.approval.replyToLabel")} value={card.replyEmail} />
      )}
      {card.requestPreview && (
        <DetailRow label={t("dashboard", "organizationAssistant.approval.requestLabel")} value={card.requestPreview} />
      )}
    </>
  );
};
